import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* detectTrackingCarrier({ payload: { trackingNumber, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.lookbooks.tracking.detectCarrier,
      data: { tracking_number: trackingNumber }
    });

    yield put(actions.detectTrackingCarrierDone(data.result));
    onSuccess && onSuccess(data.result);
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.detectTrackingCarrierFailed,
      onError,
      handledErrors,
      endpoint: api.lookbooks.tracking.detectCarrier.url
    });
  }
}

export const detectTrackingCarrierSaga = takeEvery(types.DETECT_TRACKING_CARRIER_REQUEST, detectTrackingCarrier);
